import { createContext, ReactNode, useRef, useContext } from 'react';
import {
  createFiltersStore,
  FiltersStore,
  FiltersStoreState,
  FiltersConfigs,
} from './FiltersStore';
import { useStore } from 'zustand';
import { shallow } from 'zustand/shallow';

const FiltersContext = createContext<FiltersStore | null>(null);

type FiltersProviderProps = {
  children: ReactNode | ReactNode[];
  initialFilters: FiltersStoreState['filters'];
  filtersConfigs?: FiltersConfigs;
  localStorageKey?: string;
};

export function FiltersProvider({
  children,
  initialFilters,
  filtersConfigs,
  localStorageKey,
}: FiltersProviderProps) {
  const filtersStoreRef = useRef<FiltersStore>();
  if (!filtersStoreRef.current) {
    filtersStoreRef.current = createFiltersStore(initialFilters, filtersConfigs, localStorageKey);
  }

  return (
    <FiltersContext.Provider value={filtersStoreRef.current}>{children}</FiltersContext.Provider>
  );
}

export function useFilters<T>(selector: (state: FiltersStoreState) => T) {
  const store = useContext(FiltersContext);
  if (!store) throw new Error('Missing FiltersProvider in the tree');
  return useStore(store, selector, shallow);
}
